(function() {
    'use strict';
    angular
        .module('netWordAgroApp')
        .factory('Propriedade', Propriedade);

    Propriedade.$inject = ['$resource'];

    function Propriedade ($resource) {
        var resourceUrl =  'api/propriedades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryNomesPropriedades': { 
                url: '/api/propriedades/nomesPropriedades',
                method: 'GET', 
                isArray: true},
            'queryPropriedadesAssociadas': { 
                url: '/api/propriedades/propassociadas/:idpessoa', 
                method: 'GET', 
                isArray: true},
            'queryPropriedadesCooperativa': { 
                url: '/api/propriedades/cooperativa/:idcooperativa',
                method: 'GET', 
                isArray: true},
            'queryPropriedadesParceiros': { 
                url: '/api/propriedadesParceiros/',
                method: 'GET', 
                isArray: true},
            'queryNomesPropriedadeParceiros': { 
                url: '/api/propriedades/nomesPropriedadesParceiros',
                method: 'GET', 
                isArray: true}
        });
    }
})();
